import { useRxCollectionEpocusEncounter } from "$global-providers/rxdb-provider/collections/epocus-encounter";
import { useServerTime } from "$global-providers/server-time-provider/provider";
import { toast } from "$global-providers/toast-provider";
import { useUser } from "$global-providers/user-provider/provider";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import * as Sentry from "@sentry/react";
import { useState } from "react";
import {
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../../_lib/epocus-palette";
import { cancelScanRequest } from "../../../_lib/scan-request/scan-request-operations";

export const CancelScanRequestDialog: FC<{
  open: boolean;
  encounterId: string;
  onClose: () => void;
  onCancelled: () => void;
}> = ({ open, encounterId, onClose, onCancelled }) => {
  const encounterCollection = useRxCollectionEpocusEncounter();
  const { id: userId } = useUser();
  const { getCurrentTime } = useServerTime();
  const [reason, setReason] = useState("");
  const [cancelling, setCancelling] = useState(false);

  const close = () => {
    setReason("");
    onClose();
  };

  const confirm = async () => {
    if (!encounterCollection || reason.trim() === "") return;
    setCancelling(true);
    try {
      await cancelScanRequest({
        encounterCollection,
        encounterId,
        reason,
        userId,
        now: getCurrentTime().toISOString(),
      });
      toast.success("Scan request cancelled");
      onCancelled();
    } catch (error) {
      toast.error("Couldn't cancel the request. Please try again.");
      Sentry.captureException(error);
    } finally {
      setCancelling(false);
    }
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
      <DialogTitle>
        <Typography
          style={{
            fontSize: rem(18),
            fontWeight: 700,
            color: EPOCUS_TEXT_PRIMARY,
          }}
        >
          Cancel scan request
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          style={{
            fontSize: rem(13),
            color: EPOCUS_TEXT_SECONDARY,
            marginBottom: 12,
          }}
        >
          The request is withdrawn from the worklist, so no probe can pick it
          up.
        </Typography>
        <TextField
          fullWidth
          autoFocus
          multiline
          minRows={2}
          variant="outlined"
          size="small"
          label="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          inputProps={{ "aria-label": "Cancellation reason" }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} style={{ textTransform: "none" }}>
          Keep request
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disabled={reason.trim() === "" || cancelling}
          onClick={confirm}
          style={{ textTransform: "none", fontWeight: 700 }}
        >
          Cancel request
        </Button>
      </DialogActions>
    </Dialog>
  );
};
